export const PALETTE_NEUTRAL_LIGHT = '#DEDEDE';
export const CUSTOM_ACTIVE = '#53A31C';
export const PALETTE_GREEN_500 = '#53A31C';
export const CUSTOM_ARCHIVED = '#FFB74D';
export const PALETTE_WARNING_MAIN = '#F37012';
export const PALETTE_DARK_GREY = '#505050';
export const PALETTE_BLUE_1200 = '#03559D';
export const PALETTE_ERROR_MAIN = '#CD3333';
export const CUSTOM_BLUE = '#20427E';
export const PALETTE_NEUTRAL_DARK = '#747474';
